import styled from 'styled-components';
import { grayColors } from '../../../../../../../themes/architecture/gray-colors';

export const ClientSettingsDropdownListItemSelectDefaultBox = styled.div<{ isSelected: boolean }>`
    display: flex;
    justify-content: center;
    align-items: center;

    border-radius: 50%;
    background-color: ${({ isSelected, theme }) => isSelected ? theme.colors.brandPrimary : theme.colors.backgroundMiddleDark};
    padding: 6px;
    width: 25px;
    height: 25px;

    svg {
        color: ${grayColors.gray023};
    }
`;